var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"lw-back-top",on:{"click":function($event){return _vm.$emit('toTopClick')}}},[_c('img',{attrs:{"src":require("@/assets/images/question-bank-to-top.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }